export default __webpack_public_path__ + "static/alchemy-6bda242d4fe9ff8fb080efe4ef99d1f6.jpg";